import ApplicationDetail from './ApplicationDetail/index'

export default ApplicationDetail